import Message from 'semantic-ui-react/dist/commonjs/collections/Message';
import '@purple/semantic-ui-purple-theme/components/message.css';

export default Message;
